import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { applyTheme, rememberedTheme } from './theme/applyTheme';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, HashRouter } from 'react-router-dom';

applyTheme(rememberedTheme() ?? 'default');

const useHashRouter = process.env.REACT_APP_USE_HASH_ROUTER === 'true';
const Router = useHashRouter ? HashRouter : BrowserRouter;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);

reportWebVitals();
